/* pikmoto-variants.js — sizes + frame, size persists across frame changes */
(function(){
  // === IDs map (print + frame + gift) ===
  window.PIK = window.PIK || {};
  PIK.MAP = {
    print: { variants: {            // by size
      "4x6": 44556475269260,
      "5x7": 44556475302028,
      "8x10": 44556475334796
    }},
    frame: { variants: {            // by size-color
      "4x6-black": 44510767710348, "5x7-black": 44510767743116, "8x10-black": 44510767775884,
      "4x6-oak":   44510767808652, "5x7-oak":   44510767841420, "8x10-oak":   44510767874188,
      "4x6-white": 44510767612044, "5x7-white": 44510767644812, "8x10-white": 44510767677580
    }},
    gift: { id: 44686494957708 }
  };

  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f)}
  function norm(s){return (s||'').toString().trim().toLowerCase()}
  function $all(root,sel){return Array.prototype.slice.call(root.querySelectorAll(sel))}

  function aspectFromSize(size) {
    var s = size.toLowerCase();
    if (s === '10x8' || s === '7x5' || s === '6x4') {
      return "5:4"; 
    }
    return "4:5"; 
  }

  ready(function(){
    document.querySelectorAll('[data-lenti-root]').forEach(function(root){
      var state = { size: '', frame: '' };
      var FRAME_CLASSES = ['ltc-white', 'ltc-black', 'ltc-oak'];

      function applyFrame() {
        var previewCard = root.querySelector('[data-lenti-full-preview]');
        
        // 1. Orientation Force
        var asp = aspectFromSize(state.size);
        var dims = asp.split(':').map(Number);
        var orient = dims[0] > dims[1] ? 'h' : 'v';
        if (previewCard) previewCard.setAttribute('data-orient', orient);

        // 2. Clear old classes from BOTH root and previewCard
        FRAME_CLASSES.forEach(function(c) {
          root.classList.remove(c);
          if (previewCard) {
            previewCard.classList.remove(c);
            previewCard.classList.remove(c.replace('ltc-', 'frame-')); 
          }
        });

        var summaryImg = document.getElementById('frame-preview-image-template--19629510623372__main');

        // 3. Apply State
        if (state.frame && state.frame !== "" && state.frame !== "none") {
          var colorClass = 'ltc-' + state.frame;
          root.classList.add(colorClass);
          
          if (previewCard) {
            previewCard.classList.add('frame-on');
            previewCard.classList.add(colorClass);
          }

          if (summaryImg && typeof frameImages !== 'undefined') {
            summaryImg.src = frameImages[state.frame] || '';
            summaryImg.classList.add('is-visible');
          }
          
          document.dispatchEvent(new CustomEvent('lenti:set-frame', { 
            detail: { frame: state.frame } 
          }));
        } else {
          // Strict cleanup for hidden state
          if (previewCard) {
            previewCard.classList.remove('frame-on');
          }
          if (summaryImg) {
            summaryImg.src = '';
            summaryImg.classList.remove('is-visible');
          }
          document.dispatchEvent(new CustomEvent('lenti:set-frame', { detail: { frame: '' } }));
        }

        // 4. Update Grid UI
        $all(root, '[data-lenti-frame]').forEach(function(btn) {
          var val = norm(btn.getAttribute('data-lenti-frame') || '');
          btn.classList.toggle('is-active', (state.frame !== '' && val === state.frame));
        });
      }

      function emitInit(){ window.dispatchEvent(new CustomEvent('pikmoto:variant-change',{detail:{size:state.size,frame:state.frame}})); }
      function emitFrame(){ window.dispatchEvent(new CustomEvent('pikmoto:variant-change',{detail:{frame:state.frame}})); }

      function paintActiveSize(){
        var tiles = $all(root,'[data-lenti-size]');
        var matched = false;
        tiles.forEach(function(b){
          var on = norm(b.getAttribute('data-lenti-size')) === state.size;
          b.classList.toggle('is-active', on);
          if(on) matched = true;
        });
        if(!matched && tiles.length){
          tiles[0].classList.add('is-active');
          state.size = norm(tiles[0].getAttribute('data-lenti-size'));
        }
      }

      (function variantIdSync(){
        var printInput = root.querySelector('[data-print-variant-input]');
        var frameInput = root.querySelector('[data-frame-variant-input]');
        window.addEventListener('pikmoto:variant-change', function(e){
          var d = e.detail || {}, sz = norm(d.size || state.size), col = norm(d.frame || state.frame);
          if (d.size && printInput) printInput.value = PIK.MAP.print.variants[sz] || '';
          if ((d.size || d.frame) && frameInput) frameInput.value = PIK.MAP.frame.variants[sz + '-' + col] || '';
        });
      })();

      root.addEventListener('click', function(ev){
        var t = ev.target && ev.target.closest('[data-lenti-size],[data-lenti-frame]');
        if(!t) return;
        if(t.hasAttribute('data-lenti-size')){
          ev.preventDefault();
          state.size = norm(t.getAttribute('data-lenti-size'));
          paintActiveSize();
          window.dispatchEvent(new CustomEvent('pikmoto:size-click', {detail:{size:state.size}}));
          applyFrame(); 
          return;
        }
        if(t.hasAttribute('data-lenti-frame')){
          ev.preventDefault();
          var rawVal = t.getAttribute('data-lenti-frame'); 
          // Normalize 'none' values to empty string for logic consistency
          state.frame = (rawVal && norm(rawVal) !== 'none') ? norm(rawVal) : ''; 
          applyFrame(); 
          emitFrame();
          if(typeof render === 'function') render(); 
          return;
        }
      });

      var observer = new MutationObserver(function(mutations, obs) {
        var card = root.querySelector('[data-lenti-full-preview]');
        if (card) {
          applyFrame();
          emitInit();
          obs.disconnect(); 
        }
      });
      observer.observe(root, { childList: true, subtree: true });

      var activeSizeBtn = root.querySelector('[data-lenti-size].is-active') || root.querySelector('[data-lenti-size]');
      if(activeSizeBtn) state.size = norm(activeSizeBtn.getAttribute('data-lenti-size'));
      paintActiveSize();
    });
  });
})();